/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lasteditor1Inputs */

const de__field_lasteditor1 = /** @type {(inputs: _Field_Lasteditor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Bearbeiter`)
};

/**

* @param {_Field_Lasteditor1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lasteditor1 = /** @type {((inputs?: _Field_Lasteditor1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lasteditor1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lasteditor1(inputs)
});
export { _field_lasteditor1 as "_field_lastEditor" }